import { get } from '../apiClient';
import { API_ENDPOINTS } from '../config';

const userService = {
  /**
   * Get support users
   */
  getSupportUsers: async (search = '') => {
    try {
      const url = search 
        ? `${API_ENDPOINTS.USERS.SUPPORT}?search=${encodeURIComponent(search)}`
        : API_ENDPOINTS.USERS.SUPPORT;

      const response = await get(url);

      if (response && response.responseCode === 200) {
        return {
          success: true,
          users: response.data || []
        };
      } else {
        return {
          success: false,
          error: response.responseMessage || 'Failed to retrieve support users',
          users: []
        };
      }
    } catch (error) {
      
      return {
        success: false,
        error: error.message || 'Failed to retrieve support users',
        users: []
      };
    }
  },

  /**
   * Get support team users (support + admin)
   */
  getSupportTeamUsers: async (search = '') => {
    try {
      const url = search 
        ? `${API_ENDPOINTS.USERS.SUPPORT_TEAM}?search=${encodeURIComponent(search)}`
        : API_ENDPOINTS.USERS.SUPPORT_TEAM;

      const response = await get(url);

      if (response && response.responseCode === 200) {
        return {
          success: true,
          users: response.data || []
        };
      } else {
        return {
          success: false,
          error: response.responseMessage || 'Failed to retrieve support team users',
          users: []
        };
      }
    } catch (error) {
      
      return {
        success: false,
        error: error.message || 'Failed to retrieve support team users',
        users: []
      };
    }
  }
};

export default userService;
